import { AFFILIATE_NETWORKS as AFFILIATE_NETWORK_DEFS } from "../../utils/networkConstants";
export const SALES_REPORTING_TABS = [
    { value: "AE", label: "AE Reporting" },
    { value: "BDR", label: "BDR Reporting" },
];
/* ===== Report views (AE dropdown) ===== */
// Affiliate network labels — single source of truth is the shared networkConstants.
export const AFFILIATE_NETWORKS = AFFILIATE_NETWORK_DEFS.map((n) => n.label);
// Display order for the "By Affiliate Network" report rows, and the allow-list of which networks show.
// AE and BDR use DIFFERENT orders (each matches the old portal). Each group lists name aliases that
// share a rank. Networks not listed here are hidden (filtered out), not sorted last.
const AE_AFFILIATE_NETWORK_ORDER_GROUPS = [
    ["awin"],
    ["impact"],
    ["rakuten"],
    ["no networks", "no_networks"],
    ["commission junction", "cj"],
    ["avantlink"],
    ["flexoffers"],
    ["partnerstack"],
    ["refersion"],
    ["webgains"],
    ["partnerize"],
    ["levanta"],
    ["commission factory", "commision factory"],
    ["everflow"],
    ["pepperjam"],
    ["tradedoubler"],
];
const BDR_AFFILIATE_NETWORK_ORDER_GROUPS = [
    ["awin"],
    ["impact"],
    ["rakuten"],
    ["commission junction", "cj"],
    ["commission factory", "commision factory"],
    ["partnerize"],
    ["partnerstack"],
    ["avantlink"],
    ["levanta"],
    ["refersion"],
    ["pepperjam"],
    ["webgains"],
    ["goaffpro", "go affpro"],
    ["admitad"],
    ["flexoffers"],
    ["linkconnector"],
    ["everflow"],
    ["tradedoubler"],
    ["wayward"],
    ["no networks"],
    ["no_networks"],
];
const buildNetworkOrderMap = (groups) => {
    const map = new Map();
    groups.forEach((aliases, rank) => aliases.forEach((alias) => map.set(alias, rank)));
    return map;
};
const AE_NETWORK_ORDER_MAP = buildNetworkOrderMap(AE_AFFILIATE_NETWORK_ORDER_GROUPS);
const BDR_NETWORK_ORDER_MAP = buildNetworkOrderMap(BDR_AFFILIATE_NETWORK_ORDER_GROUPS);
// Sort rank for an affiliate-network row by display name + tab (AE/BDR have different orders).
// Unknown names sort last (a stable sort keeps their relative backend order).
export const networkOrderIndex = (name, tab) => {
    const key = String(name || "").trim().toLowerCase();
    const map = tab === "BDR" ? BDR_NETWORK_ORDER_MAP : AE_NETWORK_ORDER_MAP;
    return map.has(key) ? map.get(key) : Number.MAX_SAFE_INTEGER;
};
// Channel categories (NC rows in the sheet flagged [channel]).
export const CHANNEL_CATEGORIES = ["Affiliate", "Paid Media"];
// Dropdown options match the old portal exactly.
export const VIEW_OPTIONS = [
    { value: "top_line", label: "Top Line Reporting" },
    { value: "channel", label: "By Channel" },
    { value: "recirc", label: "By Recirc Calls" },
    { value: "new_to_network", label: "By New To Network Calls" },
    { value: "existing_in_network", label: "By Existing in Network (Uncontacted) Calls" },
    { value: "tier1", label: "By Tier 1 ICP ($0 - $1M Revenue) Calls" },
    { value: "tier2", label: "By Tier 2 ICP ($1M - $10M Revenue) Calls" },
    { value: "tier3", label: "By Tier 3 ICP ($10M - $50M Revenue) Calls" },
    { value: "tier4", label: "By Tier 4 ICP ($50M+ Revenue) Calls" },
    { value: "affiliate_network", label: "By Affiliate Network" },
];
export const DEFAULT_VIEW = "top_line";
export const viewRowKind = (view) => {
    if (view === "channel")
        return "channel";
    if (view === "affiliate_network")
        return "network";
    return "team";
};
// For team views, which snapshot-bucket dimension the actuals come from.
export const TEAM_VIEW_DIMENSION = {
    top_line: "total",
    recirc: "recirc",
    new_to_network: "new_to_network",
    existing_in_network: "existing_in_network",
    tier1: "tier1",
    tier2: "tier2",
    tier3: "tier3",
    tier4: "tier4",
};
// AE sheet: Calls, Closes, Conv. Rate, Management Fees, MRR, Revenue Per Call
export const AE_METRICS = [
    { key: "calls", label: "Calls", format: "number" },
    { key: "closes", label: "Closes", format: "number" },
    { key: "conv_rate", label: "Conv. Rate", format: "percent" },
    { key: "mgmt_fees", label: "Management Fees", format: "currency" },
    { key: "mrr", label: "MRR", format: "currency" },
    { key: "revenue_per_call", label: "Revenue Per Call", format: "currency" },
];
// BDR sheet (planning-sheet order): Outreach, Booked, Conv. Rate, Meetings Happened, Happened %, Enrollments.
export const BDR_METRICS = [
    { key: "outreach", label: "Outreach", format: "number" },
    { key: "booked", label: "Booked", format: "number" },
    { key: "conv_rate", label: "Conv. Rate", format: "percent" },
    { key: "happened", label: "Meetings Happened", format: "number" },
    { key: "happened_pct", label: "Happened %", format: "percent" },
    { key: "enrollments", label: "Enrollments", format: "number" },
];
/* ===== Manual deal tracker tables ===== */
// Drawer dropdown — the stored deal type.
export const DEAL_TYPE_OPTIONS = [
    { value: "closed", label: "Closed" },
    { value: "lost", label: "Lost" },
];
// The four deal-tracker tables (each is a derived view over the deal list).
export const DEAL_TABLE_OPTIONS = [
    { value: "close_to_close", label: "Close To Close", tableTitle: "CLOSE TO CLOSE DEAL" },
    { value: "newly_added", label: "Newly Added", tableTitle: "NEWLY ADDED" },
    { value: "closed_since_last_report", label: "Closed Since Last Report", tableTitle: "CLOSED SINCE LAST REPORT" },
    { value: "lost_from_prior", label: "Lost From Prior", tableTitle: "LOST FROM PRIOR" },
];
export const EMPTY_DEAL_FORM = {
    deal_name: "",
    mrr: "",
    date: "",
    type: "",
    notes: "",
};
